import type { SVGProps } from "react";
export default function SvgBan(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-ban-icon lucide-ban"
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="M4.929 4.929 19.07 19.071" />
			<circle cx={12} cy={12} r={10} />
		</svg>
	);
}
